import { sessionConstants } from '../../../../../constants';

export const GENERIC_STATISTICS_ERROR = 'We could not load these statistics. Please try again.';

/**
 * Message to flash for a failed statistics request.
 *
 * The API reports failures as either a single message or a list of them, and the
 * server-side limits (date range, row caps, throttles) all arrive this way:
 *   400 { error: "date range must not exceed 365 days" }
 *   429 { error: "Oops! That was too quick..." }
 *
 * @param {*} error      Rejected axios error, or an Error thrown by the caller.
 * @param {string} fallback  Used when the response carries no usable message.
 */
export function statisticsErrorMessage(error, fallback = GENERIC_STATISTICS_ERROR) {
  if (error?.response?.status === 429) return sessionConstants.SERVER_LIMIT_EXCEEDED;

  const api_error = error?.response?.data?.error;

  if (Array.isArray(api_error)) return api_error.join(', ');
  if (api_error) return api_error;

  // A response we got but couldn't read leaves only axios' own "Request failed
  // with status code 500", which means nothing to the user. Errors we threw
  // ourselves have no response and do carry a real message.
  return error?.response ? fallback : error?.message || fallback;
}

export default statisticsErrorMessage;
